import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { API_BASE_URI } from "../../http/api";
import { Collection } from "../../http/collection";
import { Store } from "@ngxs/store";
import { Filter, FilterBuilder } from "../../http/filter";
import { Observable } from "rxjs";
import { DetailRequest, DetailRequestBuilder } from "../../http/detail";
import { AnyComponentOption, GanttComponentData, MeasureChartComponentData, CompiledOptionResult, ImageComponentData, NewComponentOption, ReportComponentOption, TextComponentData, IndexComponentData } from "@core/data/types/advanced-report";
import { ReportHttpHelperService } from "./advanced-report-http-helper.service";
import { TableComponentData } from "@core/data/types/Reports/report-tables";

@Injectable()
export class ReportComponentOptionService {

    constructor(
        @Inject(API_BASE_URI) private _baseUri: string,
        private _http: HttpClient,
        private _httpHelperService: ReportHttpHelperService,
    ) {}

    get<T = AnyComponentOption>(key: string, shareKey: string, detail?: DetailRequest): Observable<T> {
        const params = detail ? DetailRequestBuilder.queryParams(detail) : {};
        return this._http.get<T>(`${this._baseUri}/report-component/option/${key}`, this._httpHelperService.withShareKey({params}, shareKey));
    }

    // TODO see if we need to handle create response
    create<T = AnyComponentOption>(model: NewComponentOption< TextComponentData | ImageComponentData | MeasureChartComponentData | IndexComponentData | TableComponentData | GanttComponentData>): Observable<T> {
        return this._http.post<T>(`${this._baseUri}/report-component/option`, model);
    }

    // TODO LOOK INTO ONLY HANDELING THE STATUS, OR HOW RESPONSE SHOULD BE HANDLED
    update<T = AnyComponentOption>(key: string, model: T): Observable<T>{
        return this._http.put<T>(`${this._baseUri}/report-component/option/${key}`, model);
    }

    compile<T = CompiledOptionResult>(reportKey: string, componentKey: string, shareKey: string): Observable<T> {
        return this._http.get<T>(`${this._baseUri}/report-component/option/compile/${reportKey}/${componentKey}`, this._httpHelperService.withShareKey({}, shareKey));
    }

}